"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveViz = void 0;
var React = require("react");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var InteractiveViz = /** @class */ (function (_super) {
    __extends(InteractiveViz, _super);
    function InteractiveViz(props) {
        return _super.call(this, props) || this;
    }
    InteractiveViz.prototype.getIframeSrc = function (linkToEmbeddedViz) {
        return ("" + this.props.template.embeddedViz +
            "?:display_count=n" +
            "&:origin=viz_share_link" +
            "&:showVizHome=no" +
            "&:embed=true" +
            "&:toolbar=no" +
            "&:allowfullscreen=true" +
            "&:showDownload=no" +
            "&:showShareOptions=no" +
            ("&:device=" + WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsInteractiveViz.getDesiredDeviceType()));
    };
    InteractiveViz.prototype.render = function () {
        return (React.createElement("iframe", { "data-tb-test-id": "interactive-viz-" + this.props.template.id, src: this.getIframeSrc(this.props.template.embeddedViz), width: '100%', frameBorder: '0', className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsInteractiveViz.InteractiveIframe }));
    };
    return InteractiveViz;
}(React.Component));
exports.InteractiveViz = InteractiveViz;
//# sourceMappingURL=InteractiveViz.js.map